import React, { useEffect, useRef } from "react";

const styles = {
  initVideo: {
    height: "100dvh",
    width: '100vw',
    position: "absolute",
    top: "0",
    left: "50%",
    transform: 'translateX(-50%)',
    zIndex: "1",
    userSelect: "none",
    backgroundColor: 'black',
  },
};

export function VideoView({ src, style, hidden, loop, onLoaded, onEnded }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;

    const handleCanPlayThrough = () => {
      onLoaded();
    };
    const handleEnded = () => {
      onEnded();
    };

    if (videoElement) {
      videoElement.addEventListener("canplaythrough", handleCanPlayThrough);
      videoElement.addEventListener("ended", handleEnded);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener(
          "canplaythrough",
          handleCanPlayThrough
        );
        videoElement.removeEventListener("ended", handleEnded);
      }
    };
  }, []);

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      src={src}
      playsInline
      style={{ ...styles.initVideo, display: hidden ? "none" : "block" }}
      loop={loop}
      alt=""
    />
  );
}